export const ADD_ON_ROUTE_NAMES = {
  ADD_ON_LIST: 'addOnList',
  ADD_ON_EDIT: 'addOnEdit',
}
